"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import React from "react";

import { createSVGIcon } from "../lib/iconUtils";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4127%3A473))
 * @trackcomponent
 * @lastsynced 2025-07-08T18:36:53.166Z
 * @optimized using svgo:^3.0.2
 */
export const Share = createSVGIcon(
  <path
    d="M17.75 8.714h1.643a.82.82 0 0 1 .821.822v12.321a.82.82 0 0 1-.821.822H4.607a.82.82 0 0 1-.821-.822V9.536a.82.82 0 0 1 .821-.822H6.25M12 12.822v-11.5M8.714 4.607 12 1.322l3.286 3.285"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Share",
  {
    color: Core.icon.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
